/* src/app/timeline-artic/modals/artic-new-round-modal/artic-new-round-modal.component.scss */
/*# sourceMappingURL=artic-new-round-modal.component.css.map */
